import '../../modules/mode-components';

import * as angular from 'angular';
import * as $ from 'jquery';
import * as _ from 'lodash';

angular.module('mode.components').directive('multiselectDropdown', [
  '$timeout',
  '$compile',
  function ($timeout, $compile) {
    return function (scope, elem, attributes: any) {
      const element: any = $(elem[0]); // Get the element as a jQuery element

      // Below setup the dropdown:
      let buttonContainerClass = 'dropdown btn-group';
      let buttonClass = '';
      if (attributes.block) {
        buttonContainerClass = 'btn-group-block clearfix';
        buttonClass = ' btn-block';
      }
      let classes = '';
      if (attributes.classes) {
        classes += ' ' + attributes.classes;
      }
      let append = '';
      if (attributes.appendToBody) {
        append = 'dropdown-append-to-body';
      }
      let selectAllText = 'All Series';
      if (attributes.selectAllText) {
        selectAllText = attributes.selectAllText;
      }
      let selectAllButtonText = 'All Selected';
      if (attributes.selectAllButtonText) {
        selectAllButtonText = attributes.selectAllButtonText;
      }
      let selectAllValue = 'multiselect-all';
      if (attributes.selectAllValue) {
        selectAllValue = attributes.selectAllValue;
      }
      let dropdownClasses = '';
      if (attributes.dropdownClasses) {
        dropdownClasses = ' ' + attributes.dropdownClasses;
      }

      const templates: any = {
        filter:
          '<div class="multiselect-filter"><input class="form-control multiselect-search next-form-control form-control-sm form-control-block" type="text"><div>',
        ul: '<ul uib-dropdown-menu class="multiselect-container dropdown-menu' + dropdownClasses + '"></ul>',
      };
      if (attributes.autoHeight) {
        templates.ul =
          '<ul uib-dropdown-menu class="multiselect-container dropdown-menu' +
          dropdownClasses +
          '" select-height="' +
          attributes.autoHeight +
          '"></ul>';
      }

      /**
       * helper function to check actual select option boxes as well as visible dropdown checkboxes
       */
      function checkAllOptions(options, actualState: boolean, visibleState: boolean) {
        options.toArray().forEach((options) => {
          const checkbox = this.getInputByValue(options.value);
          checkbox.prop('checked', visibleState);
        });
        options.prop('selected', actualState);
      }

      element.multiselect({
        buttonClass: 'btn btn-sm btn-select' + buttonClass + classes,
        buttonContainer: '<div uib-dropdown ' + append + ' class="' + buttonContainerClass + '" />',
        maxHeight: attributes.autoHeight ? null : 200,
        maxItems: attributes.maxItems,
        optimize: attributes.optimizeMultiselect,
        buttonWidth: attributes.block ? '100%' : 'auto',
        selectedClass: !!attributes.selectAll ? '' : 'active',
        appendToBody: !!attributes.appendToBody,
        id: attributes.multiselectDropdown,
        includeSelectAllOption: !!attributes.selectAll && !attributes.initWithoutSelectAll,
        selectAllText: selectAllText,
        selectAllValue: selectAllValue,
        enableFiltering: !!attributes.multiselectFilter,
        enableCaseInsensitiveFiltering: !!attributes.multiselectFilter,
        filterPlaceholder: 'Find…',
        templates: templates,
        buttonTitle: function (options, select) {
          if (options.length === 0) {
            return this.nonSelectedText;
          } else {
            let selected = '';
            options.each(function () {
              selected += $(this).text().trim() + ', ';
            });
            return selected.substr(0, selected.length - 2);
          }
        },
        buttonText: function (options, $select) {
          if (attributes.selectAll && $('option[value="' + selectAllValue + '"]:selected', $select).length) {
            const option = $('option[value="' + selectAllValue + '"]:selected', $select).first();
            checkAllOptions.call(this, option.siblings(), false, true);
            return selectAllButtonText + ' <i class="icon-dropdown-arrow"></i>';
          }
          if (options.length === 0) {
            return '<i class="icon-dropdown-arrow"></i>';
          } else if (options.length > 1) {
            return (
              (<any>_.first(options)).text +
              ' + ' +
              (options.length - 1) +
              ' more selected <i class="icon-dropdown-arrow"></i>'
            );
          } else {
            return (<any>_.first(options)).text + ' <i class="icon-dropdown-arrow"></i>';
          }
        },
        // Replicate the native functionality on the elements so
        // that angular can handle the changes for us.
        onChange: function (optionElement, checked) {
          optionElement.prop('selected', false);
          if (checked) {
            optionElement.prop('selected', true);
            if (attributes.selectAll && optionElement.prop('value') !== selectAllValue) {
              // user has checked non select all option
              checkAllOptions.call(this, optionElement.siblings('[value="' + selectAllValue + '"]'), false, false);
              $(this.getInputByValue(optionElement.siblings('[value="' + selectAllValue + '"]')[0].value)).addClass(
                'partially-selected'
              );
            } else if (attributes.selectAll && optionElement.prop('value') === selectAllValue) {
              // user has checked select all option
              const anySelected = !!optionElement.siblings(':selected').length;
              // if any siblings are selected then deselect everything
              // otherwise select all and fake select everything else
              checkAllOptions.call(this, optionElement, !anySelected, !anySelected);
              checkAllOptions.call(this, optionElement.siblings(), false, !anySelected);
              $(this.getInputByValue(optionElement[0].value)).removeClass('partially-selected');
            }
          } else if (attributes.selectAll && optionElement.prop('value') === selectAllValue) {
            // user has unchecked select all value
            // deselecting select all so deselect everything
            checkAllOptions.call(this, optionElement.siblings(), false, false);
            $(this.getInputByValue(optionElement[0].value)).removeClass('partially-selected');
          } else if (
            attributes.selectAll &&
            optionElement.prop('value') !== selectAllValue &&
            optionElement.siblings('[value="' + selectAllValue + '"]:selected').length
          ) {
            // user has unchecked non select all option and select all was checked
            // deselecting a non select all checkbox so select everything else (expect select all)
            checkAllOptions.call(this, optionElement.siblings('[value!="' + selectAllValue + '"]'), true, true);
            checkAllOptions.call(this, optionElement.siblings('[value="' + selectAllValue + '"]'), false, false);
            $(this.getInputByValue(optionElement.siblings('[value="' + selectAllValue + '"]')[0].value)).addClass(
              'partially-selected'
            );
          }
          element.change();
        },
        onMultipleChange: function (optionElements, checked) {
          angular.forEach(optionElements, function (optionElement) {
            optionElement.prop('selected', false);
            if (checked) {
              optionElement.prop('selected', true);
            }
          });
          element.change();
        },
        onCreateOption: function (option, input) {
          if (
            attributes.selectAll &&
            option.prop('value') === selectAllValue &&
            !option.prop('selected') &&
            option.siblings(':selected').length
          ) {
            // select all is not selected but other options are then add deselect class
            input.addClass('partially-selected');
          }
        },
      });

      // must tell angular-ui-bootstrap about new dropdown
      $compile(element.next())(scope);

      // Watch for any changes to the length of our select element
      $timeout(() => {
        scope.$watch(
          function () {
            return _.map(element[0].options, function (o: any) {
              return o.label;
            });
          },
          function (len) {
            $timeout(function () {
              element.multiselect('rebuild');
            });
          },
          true
        );
      });

      // Watch for any changes from outside the directive and refresh
      scope.$watch(attributes.ngModel, function (model) {
        $timeout(function () {
          element.multiselect('refresh');
        });
      });
    };
  },
]);
